import axios from '@/common/axios'
import {
  COMMON
} from '../constants/funcUrl'

/**
 * 公共类
 */
const commonAction = {
  login: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.LOGIN, params);
  },
  changePassword: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.CHANGEPASSWORD, params);
  },
  getDepts: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONDEPTS, params);
  },
  getZdDepts: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONZDDEPTS, params);
  },
  getTransferDepts: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONTRANSFERDEPTS, params);
  },
  getCaseReasons: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONCASEREASONS, params);
  },
  getDocUseTypes: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.COMMONDOCUSETYPES, params);
  },
  // 上传文件
  postUploadFile: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.COMMONUPLOADFILE, params);
  },

  getDeptUsers: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.USERDEPTUSERS, params);
  },

  getDocCatalogs: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCCATALOGDOCCATALOGS, params);
  },
  getAllDocCatalogs: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCCATALOGALLDOCCATALOGS, params);
  },
  postDocCatalog: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.DOCCATALOG, params);
  },
  putDocCatalog: ({
    commit
  }, params) => {
    return axios.putFormDataAsync(commit, COMMON.DOCCATALOG, params);
  },

  getDocInRecords: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCINRECORDS, params);
  },
  getDocInCodeSequence: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCINCODESEQUENCE, params);
  },
  postDocInRecord: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.DOCINRECORD, params);
  },
  deleteDocInRecord: ({
    commit
  }, params) => {
    return axios.deleteAsyncWithConcat(commit, COMMON.DOCINRECORD, params);
  },

  getDocOutRecords: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCOUTRECORDS, params);
  },
  getDocOutDocCatalogs: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCOUTDOCCATALOGS, params);
  },
  postDocOutRecord: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.DOCOUTRECORD, params);
  },
  deleteDocOutRecord: ({
    commit
  }, params) => {
    return axios.deleteAsyncWithConcat(commit, COMMON.DOCOUTRECORD, params);
  },

  getDocReceiveRecords: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCRECEIVERECORDS, params);
  },
  getDocReceiveDocCatalogs: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCRECEIVEDOCCATALOGS, params);
  },
  postDocReceiveRecord: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.DOCRECEIVEDOC, params);
  },

  getDocs: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCDOCS, params);
  },
  getDocFeedbacks: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCFEEDBACKS, params);
  },
  postDocFeedback: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.DOCFEEDBACK, params);
  },

  getDocStockStats: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCSTOCKSTATS, params);
  },
  getDocUseStats: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.DOCUSESTATS, params);
  },

  getCases: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.CASECASES, params);
  },
  getMyCases: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.CASEMYCASES, params);
  },
  getCaseDetails: ({
    commit
  }, params) => {
    return axios.getAsyncWithConcat(commit, COMMON.CASEDETAILS, params);
  },
  getReceiveCases: ({
    commit
  }, params) => {
    return axios.getAsync(commit, COMMON.CASERECEIVECASES, params);
  },
  postCase: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.CASE, params);
  },
  deleteCase: ({
    commit
  }, params) => {
    return axios.deleteAsyncWithConcat(commit, COMMON.CASE, params);
  },
  postReceiveCase: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.CASERECEIVE, params);
  },
  postRecordCase: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.CASERECORD, params);
  },
  postPenaltyCase: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.CASEPENALTY, params);
  },
  postCloseCase: ({
    commit
  }, params) => {
    return axios.postFormDataAsync(commit, COMMON.CASECLOSE, params);
  }
}

export default commonAction;



// WEBPACK FOOTER //
// ./src/store/sczdzf/actions/commonAction.js